import React from "react";
import logo from "../../../img/spotify.svg"

export const SpotifyLogo = () => (
    <div className="social spotify">
        <img src={logo} alt="Spotify" />
    </div>
);
